<template>
  <div class="container">
    <div
      style="display: flex; align-items: center; gap: 16px; margin-bottom: 16px"
    >
      <a-form :model="handleList" class="search-form" @submit="handleList">
        <a-form-item>
          <a-button
            type="primary"
            @click="openAdd = true"
            style="margin-bottom: 0"
          >
            添加监所
          </a-button>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">类别：</div>
            <a-select style="width: 100px" v-model:value="listRequest.category">
              <a-select-option :value="1">监所</a-select-option>
              <a-select-option :value="2">看守所</a-select-option>
            </a-select>
          </div>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">省份：</div>
            <a-input placeholder="省份" v-model:value="listRequest.province" />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">城市：</div>
            <a-input placeholder="省份" v-model:value="listRequest.city" />
          </div>
        </a-form-item>
        <a-form-item>
          <div class="form-item-content">
            <div class="label">县区：</div>
            <a-input placeholder="省份" v-model:value="listRequest.district" />
          </div>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" html-type="submit">搜索</a-button>
          <a-button style="margin-left: 10px" @click="resetSearch"
            >重置
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <a-table
      :columns="columns"
      :data-source="supervisorList"
      :pagination="{
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      }"
      :scroll="{ x: 2300, y: 800 }"
      bordered
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'category'">
          <span v-if="record.category === 1">监所</span>
          <span v-if="record.category === 2">看守所</span>
        </template>
        <template v-if="column.dataIndex === 'is_right'">
          <span v-if="record.is_right === 1">已确认</span>
          <span v-if="record.is_right === 2">暂未确认</span>
        </template>
        <template v-if="column.dataIndex === 'is_connect'">
          <span v-if="record.is_connect === 1">已确认</span>
          <span v-if="record.is_connect === 2">暂未确认</span>
        </template>
        <template v-if="column.dataIndex === 'communication'">
          <div style="display: flex; gap: 8px">
            <a-tag
              v-if="record.communication && record.communication.includes(1)"
              color="green"
              >明信片
            </a-tag>
            <a-tag
              v-if="record.communication && record.communication.includes(2)"
              color="blue"
              >普通信件
            </a-tag>
            <a-tag
              v-if="record.communication && record.communication.includes(3)"
              color="red"
              >EMS
            </a-tag>
          </div>
        </template>
        <template v-else-if="column.dataIndex === 'image_url'">
          <a-image
            :src="ToImage(record.image_url)"
            style="height: 60px; width: auto"
          />
        </template>
        <template v-else-if="column.dataIndex === 'is_delete'">
          <a-tag v-if="record.is_delete === 1" color="green">正常</a-tag>
          <a-tag v-if="record.is_delete === 2" color="red">回收站</a-tag>
        </template>
        <template v-else-if="column.dataIndex === 'create_at'">
          <span
            >{{ dayjs(record.create_at).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </template>
        <template v-else-if="column.dataIndex === 'operator'">
          <a-button
            @click="handleUpdate(record)"
            type="primary"
            :style="{ marginRight: '8px' }"
            >编辑
          </a-button>
          <a-button
            @click="submitDelete(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }"
            >删除
          </a-button>
          <a-button
            @click="submitDrop(record)"
            type="primary"
            :style="{
              backgroundColor: '#ff4d4f',
              color: 'white',
            }"
            >彻底删除
          </a-button>
        </template>
      </template>
    </a-table>
    <a-modal
      v-model:open="openAdd"
      title="添加监所数据"
      @ok="submitAdd"
      cancelText="取消"
    >
      <a-form :model="addRequest">
        <a-form-item label="名称">
          <a-input v-model:value="addRequest.name" />
        </a-form-item>
        <a-form-item label="电话">
          <a-input v-model:value="addRequest.phone" />
        </a-form-item>
        <a-form-item label="省份">
          <a-input v-model:value="addRequest.province" />
        </a-form-item>
        <a-form-item label="城市">
          <a-input v-model:value="addRequest.city" />
        </a-form-item>
        <a-form-item label="县区">
          <a-input v-model:value="addRequest.district" />
        </a-form-item>
        <a-form-item label="地址">
          <a-textarea
            v-model:value="addRequest.address"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
          <a-button
            type="primary"
            size="small"
            @click="copyContent(addRequest.address)"
          >
            一键复制
          </a-button>
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="addRequest.category">
            <a-select-option :value="1">监所</a-select-option>
            <a-select-option :value="2">看守所</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="地址是否确认">
          <a-radio-group v-model:value="addRequest.is_right">
            <a-radio :value="1">已确认</a-radio>
            <a-radio :value="2">暂未确认</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="未判决去人可以通信">
          <a-radio-group v-model:value="addRequest.is_connect">
            <a-radio :value="1">已确认</a-radio>
            <a-radio :value="2">暂未确认</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="通讯方式">
          <a-checkbox-group v-model:value="addRequest.communication">
            <a-checkbox :value="1">明信片</a-checkbox>
            <a-checkbox :value="2">普通信件</a-checkbox>
            <a-checkbox :value="3">EMS</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="补充内容">
          <a-textarea
            v-model:value="addRequest.content"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal
      v-model:open="openUpdate"
      title="修改监所数据"
      @ok="submitUpdate"
      cancelText="取消"
    >
      <a-form :model="updateRequest" style="margin-top: 20px">
        <a-form-item label="名称">
          <a-input v-model:value="updateRequest.name" />
        </a-form-item>
        <a-form-item label="电话">
          <a-input v-model:value="updateRequest.phone" />
        </a-form-item>
        <a-form-item label="省份">
          <a-input v-model:value="updateRequest.province" />
        </a-form-item>
        <a-form-item label="城市">
          <a-input v-model:value="updateRequest.city" />
        </a-form-item>
        <a-form-item label="县区">
          <a-input v-model:value="updateRequest.district" />
        </a-form-item>
        <a-form-item label="地址">
          <a-textarea
            v-model:value="updateRequest.address"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
        </a-form-item>
        <a-form-item label="类别">
          <a-select v-model:value="updateRequest.category">
            <a-select-option :value="1">监所</a-select-option>
            <a-select-option :value="2">看守所</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="地址是否确认">
          <a-radio-group v-model:value="updateRequest.is_right">
            <a-radio :value="1">已确认</a-radio>
            <a-radio :value="2">暂未确认</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="未判决去人可以通信">
          <a-radio-group v-model:value="updateRequest.is_connect">
            <a-radio :value="1">已确认</a-radio>
            <a-radio :value="2">暂未确认</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item label="通讯方式">
          <a-checkbox-group v-model:value="updateRequest.communication">
            <a-checkbox :value="1">明信片</a-checkbox>
            <a-checkbox :value="2">普通信件</a-checkbox>
            <a-checkbox :value="3">EMS</a-checkbox>
          </a-checkbox-group>
        </a-form-item>
        <a-form-item label="补充内容">
          <a-textarea
            v-model:value="updateRequest.content"
            :auto-size="{ minRows: 2, maxRows: 5 }"
          />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model:value="updateRequest.is_delete">
            <a-select-option :value="0">"</a-select-option>
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="2">回收站</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script setup lang="ts">
import { onMounted, reactive, ref } from "vue";
import { message } from "ant-design-vue";
import { ToImage } from "@/utils/image";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Template } from "@/api/models/template/Template";
import { SupervisorService } from "@/api/services/SupervisorService";
import { SupervisorListRequest } from "@/api/models/supervisor/SupervisorListRequest";
import { Supervisor } from "@/api/models/supervisor/Supervisor";
import { SupervisorAddRequest } from "@/api/models/supervisor/SupervisorAddRequest";
import { SupervisorUpdateRequest } from "@/api/models/supervisor/SupervisorUpdateRequest";

const total = ref<number>(0);

const listRequest = reactive<SupervisorListRequest>({
  current: 1,
  size: 20,
  content: "",
  province: "",
  city: "",
  district: "",
});

// @ts-ignore
const supervisorList = ref<Supervisor[]>([{}]);

const copyContent = async (content: string) => {
  await navigator.clipboard.writeText(content);
  message.success("复制成功");
};

const handleList = async () => {
  const res = await SupervisorService.ListAll(listRequest);
  if (res.code === 0) {
    supervisorList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const resetSearch = () => {
  listRequest.current = 1;
  listRequest.size = 20;
  listRequest.content = "";
  listRequest.province = "";
  listRequest.city = "";
  listRequest.district = "";
  listRequest.category = undefined;
  handleList();
};

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<SupervisorAddRequest>({
  name: "",
  phone: "",
  province: "",
  city: "",
  district: "",
  address: "",
  is_right: 1,
  is_connect: 1,
  communication: [],
  content: "",
});

const submitAdd = async () => {
  const res = await SupervisorService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<SupervisorUpdateRequest>({
  id: 0,
  is_delete: 0,
  name: "",
  phone: "",
  province: "",
  city: "",
  district: "",
  address: "",
  category: 0,
  is_right: 0,
  is_connect: 0,
  communication: [],
  content: "",
});

const handleUpdate = (record: Template) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await SupervisorService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Template) => {
  const res = await SupervisorService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Template) => {
  const res = await SupervisorService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "省份",
    dataIndex: "province",
    align: "center",
  },
  {
    title: "城市",
    dataIndex: "city",
    align: "center",
  },
  {
    title: "县区",
    dataIndex: "district",
    align: "center",
  },
  {
    title: "地址",
    dataIndex: "address",
    align: "center",
  },
  {
    title: "分类",
    dataIndex: "category",
    align: "center",
  },
  {
    title: "地址是否正确",
    dataIndex: "is_right",
    align: "center",
  },
  {
    title: "未判决去人可以通信",
    dataIndex: "is_connect",
    align: "center",
  },
  {
    title: "通讯方式",
    dataIndex: "communication",
    align: "center",
    width: 250,
  },
  {
    title: "其它补充",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
    width: 300,
  },
];
</script>

<style scoped>
.container {
  border: 1px solid #d9d9d9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 98%;
  margin-left: 1%;
  background-color: white;
  margin-top: 16px;
}

.search-form {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-top: 10px;
}

.form-item-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.label {
  white-space: nowrap;
}
</style>
